export default __webpack_public_path__ + "static/map-vignette-2022-e48b4066e96ef7bc63158478a1f00c57.png";